import { render } from "./OneStopGideTopComponent.vue?vue&type=template&id=6bc2e5a4&ts=true"
import script from "./OneStopGideTopComponent.vue?vue&type=script&lang=ts"
export * from "./OneStopGideTopComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__